import {
    Document,
    Page,
    Text,
    View,
    StyleSheet,
    Image,
    Font,
  } from "@react-pdf/renderer";
  
import { useEffect, useState } from "react";
  Font.register({
    family: "Roboto",
    fonts: [
      { src: "http://fonts.gstatic.com/s/roboto/v15/W5F8_SL0XFawnjxHGsZjJA.ttf" },
      {
        src: "http://fonts.gstatic.com/s/roboto/v15/bdHGHleUa-ndQCOrdpfxfw.ttf",
        fontStyle: "normal",
        fontWeight: 700,
      },
    ],
  });
  
  // Definir los estilos
  const styles = StyleSheet.create({
    page: {
      fontSize: 12,
      color: "#454546",
      height: "100%",
    },
    header: {
      paddingHorizontal: 40,
      paddingTop: 40,
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      marginBottom: 20,
    },
    logo: {
      width: "auto",
      height: 30,
    },
    title: {
      textAlign: "center",
      fontSize: 16,
      fontWeight: 700,
      fontFamily: "Roboto",
      color: "#000",
      marginBottom: 20,
    },
    section: {
      paddingHorizontal: 40,
      marginBottom: 10,
    },
    textBold: {
      color: "#000",
      fontSize: 12,
      fontFamily: "Roboto",
    },
    text: {
      marginBottom: 5,
      fontSize: 12,
      fontFamily: "Roboto",
    },
    footerImage: {
      width: "100%",
      height: "8%",
      position: "absolute",
      bottom: 0,
    },
    watermark: {
      position: "absolute",
      top: "35%",
      left: "15%",
      width: "70%",
      opacity: 0.2,
      zIndex: "-10",
    },
    information: {
      display: "flex",
      flexWrap: "wrap",
      flexDirection: "row",
      justifyContent: "space-between",
      paddingHorizontal: 40,
      marginBottom: 10,
    },

    table: {
      display: 'table',
      width: 'auto',
      margin: 10,  
    },

    row: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: 5,
    },

    // striped: {
    //   backgroundColor: '#f9f9f9',
    // },
    
    // cell: {
    //   flex: 1, // Esto asegura que todas las celdas tengan el mismo tamaño
    //   textAlign: 'center',
    //   borderWidth: 1,
    //   borderColor: '#ddd',
    //   padding: 8,
    // },

    cell: {
      display: 'table-cell',
      padding: 2,
      textAlign: 'center',
      alignItems: 'center',
      verticalAlign: 'middle',  
    },

    striped: {
      backgroundColor: '#e0e0e0',
    },
    
    headerTable: {
      backgroundColor: '#f0f0f0',
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
    },

    horizontalLine: {
      borderBottomWidth: 1,
      borderBottomColor: '#000',
      borderBottomStyle: 'solid',
    },
  });
  
  const OdontogramaPdf = ({ nombre,
    edad,
    fecha, 
    lugarAtencion,
    seguro,
    odontogramasActuales,
    odontogramasBackEnd,
    costoOdontograma
  }) => {

    const combinedOdontogramas = [
      ...odontogramasActuales,
      ...odontogramasBackEnd.filter(
            (odontograma) =>
              !odontogramasActuales.some((d) => d.diente === odontograma.diente)
          )
    ];


    const odontogramas = [
      { piezaDental: "18", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "17", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "16", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "15", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "55", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "14", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "54", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "13", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "53", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "12", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "52", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "11", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "51", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "21", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "61", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "22", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "62", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "23", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "63", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "24", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "64", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "35", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "65", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "26", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "27", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "28", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "38", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "37", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "36", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "35", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "75", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "34", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "74", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "33", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "73", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "32", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "72", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "31", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "71", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "41", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "81", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "42", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "82", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "43", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "83", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "44", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "84", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "45", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "85", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "46", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "47", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "48", diagnostico: "", tratamiento: "", costo: "" },
      { piezaDental: "OTROS TX", diagnostico: "", tratamiento: "", costo: "" }
    ];

    const nuevoOdontogramas = odontogramas.map((d) => {
      const odonto = combinedOdontogramas.find((od) => d.piezaDental === od.diente);
      if (odonto) {
        return {
          piezaDental: odonto.diente,
          diagnostico: odonto.diagnostico,
          tratamiento: odonto.tratamiento,
          costo: odonto.costo
        }
      }
      return d;
    })

    return (
      <Document>
        <Page style={styles.page}>
          <Image style={styles.watermark} src="/images/logoCorazon.png" />
          {/* Header */}
          <View style={styles.header}>
            <Image style={styles.logo} src="/images/logo3.png" />
            <Image style={styles.logo} src="/images/logoCorazons.png" />
          </View>
  
          {/* Title */}
          <Text style={styles.title}>ODONTOGRAMA</Text>
  
          {/* Patient Information */}
          <View style={styles.information}>
            <View style={styles.gridItem}>
              <Text style={styles.text}>
                <Text style={styles.textBold}>Nombre:</Text> {nombre}
              </Text>
              <Text style={styles.text}>
                <Text style={styles.textBold}>Edad:</Text> {edad}
              </Text>
              <Text style={styles.text}>
                <Text style={styles.textBold}>Lugar de atención:</Text>{" "}
                {lugarAtencion}
              </Text>
            </View>
            <View style={styles.gridItem}>
              <Text style={styles.text}>
                <Text style={styles.textBold}>Fecha:</Text> {fecha}
              </Text>
              <Text style={styles.text}>
                <Text style={styles.textBold}>Seguro:</Text> {seguro}
              </Text>
            </View>
          </View>
  
          {/* Odontograma Details */}

          <View style={styles.table}>
            {/* Fila de encabezado */}
            <View style={[styles.row, styles.headerTable]}>
                <Text style={styles.cell}>#</Text>
                <Text style={styles.cell}>Pieza dental</Text>
                <Text style={styles.cell}>Diagnostico</Text>
                <Text style={styles.cell}>Tratamiento</Text>
                <Text style={styles.cell}>Costo</Text>
            </View>
            <View style={styles.horizontalLine} />
              {/* Fila de datos */}
              <>
                {nuevoOdontogramas.map((odontograma, index) => (
                  <>
                    {/* Sin index y con todas las piezas para que el odontologo realice mas modificaciones a mano */}
                    {/* <View key={index} style={[styles.row, styles.headerTable, index % 2 === 0 ? {} : styles.striped]}>
                      <Text style={styles.cell}>
                          {odontograma?.piezaDental}
                      </Text>
                  
                      <Text style={styles.cell}>
                          {odontograma?.diagnostico}
                      </Text>
                  
                      <Text style={styles.cell}>
                          {odontograma?.tratamiento}
                      </Text>
                  
                      <Text style={styles.cell}>
                          {odontograma?.costo}
                      </Text>
                    </View> */}
                    {/* Con index y con solo las piezas que se registraron */}
                    {
                      odontograma?.diagnostico !== "" &&
                      (
                        <>
                          <View key={index} style={[styles.row, styles.headerTable, index % 2 === 0 ? {} : styles.striped]}>
                            <Text style={styles.cell}>
                                {index + 1}
                            </Text>
                            <Text style={styles.cell}>
                                {odontograma?.piezaDental}
                            </Text>
                        
                            <Text style={styles.cell}>
                                {odontograma?.diagnostico}
                            </Text>
                        
                            <Text style={styles.cell}>
                                {odontograma?.tratamiento}
                            </Text>
                        
                            <Text style={styles.cell}>
                                {odontograma?.costo}
                            </Text>
                          </View>
                          <View style={styles.horizontalLine} />
                        </>
                        )
                    }
                  </>
                ))}
                <View style={[styles.row, styles.headerTable]}>
                  <Text style={styles.cell}>
                      Total
                  </Text>
              
                  <Text style={styles.cell}>
                      { costoOdontograma }
                  </Text>
                </View>
              </>
            </View>
          {/* Footer */}
          {/* <Image style={styles.footerImage} src="/images/footerImage.png" /> */}
        </Page>
      </Document>
    );
  };
  
  export default OdontogramaPdf;
  